import {
  SET_FORECAST_RC_DATA,
} from "./mutations";

const initialState = {
  currentForecastRC: null
};

const forecastRCReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FORECAST_RC_DATA: {
      return { ...state, currentForecastRC: payload }
    }

    default:
      return state;
  }
};

export default forecastRCReducer;
